// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Organization Management — enterprise module shell */
.org-mgmt-page {
  min-height: calc(100vh - 120px);
  padding-bottom: 5rem;
}

.org-mgmt-hero {
  background: linear-gradient(135deg, #f8fafc 0%, #eef2ff 100%);
  border: 1px solid rgba(15, 23, 42, 0.06);
}

.org-section-card {
  border: 1px solid rgba(15, 23, 42, 0.08) !important;
  box-shadow: 0 0.35rem 1.25rem rgba(15, 23, 42, 0.06) !important;
}

.org-section-card .card-header {
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.org-sticky-actions {
  position: sticky;
  bottom: 0;
  z-index: 20;
  margin-left: -0.25rem;
  margin-right: -0.25rem;
  padding: 0.5rem 0.875rem;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(8px);
  border-top: 1px solid rgba(15, 23, 42, 0.08);
  box-shadow: 0 -0.35rem 1rem rgba(15, 23, 42, 0.06);
}

.org-hierarchy-split {
  min-height: 520px;
}

.org-tree-panel {
  background: #fafbfc;
  border-right: 1px solid rgba(15, 23, 42, 0.08);
}

.org-tree-scroll {
  max-height: calc(100vh - 280px);
  overflow: auto;
}

/* Type emoji / icon — match small tree row text (not display size) */
.org-tree-type-icon {
  font-size: 0.8125rem;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.125rem;
}

.org-tree-node .badge {
  font-size: 0.65rem;
  font-weight: 600;
  padding: 0.2em 0.45em;
}

.org-context-menu .list-group-item {
  font-size: 0.875rem;
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
}

.org-context-menu .list-group-item i {
  font-size: 0.875rem;
  vertical-align: -0.05em;
}

.org-tree-node {
  border-radius: 0.35rem;
  transition: background 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.org-tree-node:hover {
  background: rgba(99, 102, 241, 0.06);
}

.org-tree-node.selected {
  background: rgba(99, 102, 241, 0.12);
  outline: 1px solid rgba(99, 102, 241, 0.35);
}

.org-tree-connector {
  border-color: rgba(15, 23, 42, 0.08) !important;
}

.org-tree-node--supplier {
  background: rgba(245, 158, 11, 0.07);
}

.org-tree-node--supplier:hover {
  background: rgba(245, 158, 11, 0.12);
}

.org-tree-node--supplier.selected {
  background: rgba(245, 158, 11, 0.18);
  outline: 1px solid rgba(217, 119, 6, 0.4);
}

.org-tree-supplier-tag {
  letter-spacing: 0.05em;
  font-size: 0.58rem;
  vertical-align: middle;
}

.org-supplier-detail-card {
  border-radius: 0.5rem;
  background: linear-gradient(180deg, rgba(255, 251, 235, 0.55) 0%, #fff 2rem);
}

.org-tree-level-dot {
  width: 0.3rem;
  border-radius: 999px;
  align-self: stretch;
  min-height: 1.125rem;
}

.org-detail-panel {
  background: #fff;
}

.org-context-menu {
  position: fixed;
  z-index: 1050;
  min-width: 11rem;
  box-shadow: 0 0.5rem 1.5rem rgba(15, 23, 42, 0.15);
}

.org-pricing-priority .list-group-item {
  font-size: 0.875rem;
}

@media (max-width: 767.98px) {
  .org-tree-scroll {
    max-height: 220px;
  }
}

/* —— Landing & workspace (master UI) —— */
.org-mgmt-hero--compact {
  margin-bottom: 1.25rem !important;
}

.org-landing__header {
  border-radius: 0.75rem 0.75rem 0 0;
}

.org-landing__search {
  min-width: min(100%, 280px);
}

.org-landing__table thead th {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--bs-secondary-color);
  border-bottom-width: 1px;
}

.org-landing__row {
  transition: background 0.15s ease;
}

.org-landing__row:hover {
  background: rgba(13, 110, 253, 0.04);
}

.org-empty-state__icon {
  font-size: 2.5rem;
  color: var(--bs-secondary-color);
  opacity: 0.45;
}

.org-workspace-tabs .nav-link {
  border: 1px solid transparent;
  color: var(--bs-secondary-color);
  font-weight: 500;
  font-size: 0.875rem;
  padding: 0.5rem 1rem;
  transition: color 0.15s ease, background 0.15s ease, border-color 0.15s ease;
}

.org-workspace-tabs .nav-link:hover {
  color: var(--bs-primary);
  background: rgba(13, 110, 253, 0.06);
}

.org-workspace-tabs .nav-link.active {
  color: var(--bs-primary);
  background: #fff;
  border-color: rgba(15, 23, 42, 0.08);
  border-bottom-color: #fff;
  margin-bottom: -1px;
}

.org-workspace-card {
  border: 1px solid rgba(15, 23, 42, 0.08) !important;
  border-top: none !important;
  border-radius: 0 0 0.75rem 0.75rem !important;
  background: #fff;
  min-height: 280px;
}

.org-panel-card {
  border-radius: 0.75rem !important;
}

.org-details-tab .form-label {
  font-weight: 500;
}

.org-accordion .accordion-button {
  font-weight: 600;
  font-size: 0.875rem;
  padding: 0.65rem 1rem;
}

.org-accordion .accordion-button:not(.collapsed) {
  background: rgba(13, 110, 253, 0.06);
  color: var(--bs-body-color);
}

/* Customer onboarding — tabbed form (replaces accordion) */
.customer-onboard-tabs {
  position: relative;
  z-index: 1;
}

.customer-onboard-pan {
  border-color: rgba(15, 23, 42, 0.08) !important;
  min-height: 320px;
}

.customer-onboarding-form .cust-form-block:not(:last-child) {
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  padding-bottom: 1.25rem;
  margin-bottom: 1.5rem !important;
}

/* Compact react-select — same visual scale as User Management (form-control-sm) */
.customer-onboarding-form .react-select__control,
.org-details-tab .react-select__control {
  min-height: 31px;
  font-size: 0.875rem;
}

.customer-onboarding-form .react-select__single-value,
.customer-onboarding-form .react-select__input-container,
.customer-onboarding-form .react-select__placeholder,
.org-details-tab .react-select__single-value,
.org-details-tab .react-select__input-container,
.org-details-tab .react-select__placeholder {
  font-size: 0.875rem;
}

.customer-onboarding-form .react-select__indicators,
.org-details-tab .react-select__indicators {
  height: 29px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/tenant/organization-management/organization-management.css"],"names":[],"mappings":"AAAA,sDAAsD;AACtD;EACE,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,6DAA6D;EAC7D,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;EACnD,+DAA+D;AACjE;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,wBAAwB;EACxB,qCAAqC;EACrC,0BAA0B;EAC1B,4CAA4C;EAC5C,kDAAkD;AACpD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA,qEAAqE;AACrE;EACE,oBAAoB;EACpB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,4EAA4E;EAC5E,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,4EAA4E;AAC9E;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,0CAA0C;AAC1C;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,4EAA4E;AAC9E;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mDAAmD;EACnD,2BAA2B;EAC3B,6CAA6C;EAC7C,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,+CAA+C;EAC/C,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA,kFAAkF;AAClF;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;AACd","sourcesContent":["/* Organization Management — enterprise module shell */\n.org-mgmt-page {\n  min-height: calc(100vh - 120px);\n  padding-bottom: 5rem;\n}\n\n.org-mgmt-hero {\n  background: linear-gradient(135deg, #f8fafc 0%, #eef2ff 100%);\n  border: 1px solid rgba(15, 23, 42, 0.06);\n}\n\n.org-section-card {\n  border: 1px solid rgba(15, 23, 42, 0.08) !important;\n  box-shadow: 0 0.35rem 1.25rem rgba(15, 23, 42, 0.06) !important;\n}\n\n.org-section-card .card-header {\n  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);\n}\n\n.org-sticky-actions {\n  position: sticky;\n  bottom: 0;\n  z-index: 20;\n  margin-left: -0.25rem;\n  margin-right: -0.25rem;\n  padding: 0.5rem 0.875rem;\n  background: rgba(255, 255, 255, 0.92);\n  backdrop-filter: blur(8px);\n  border-top: 1px solid rgba(15, 23, 42, 0.08);\n  box-shadow: 0 -0.35rem 1rem rgba(15, 23, 42, 0.06);\n}\n\n.org-hierarchy-split {\n  min-height: 520px;\n}\n\n.org-tree-panel {\n  background: #fafbfc;\n  border-right: 1px solid rgba(15, 23, 42, 0.08);\n}\n\n.org-tree-scroll {\n  max-height: calc(100vh - 280px);\n  overflow: auto;\n}\n\n/* Type emoji / icon — match small tree row text (not display size) */\n.org-tree-type-icon {\n  font-size: 0.8125rem;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.125rem;\n}\n\n.org-tree-node .badge {\n  font-size: 0.65rem;\n  font-weight: 600;\n  padding: 0.2em 0.45em;\n}\n\n.org-context-menu .list-group-item {\n  font-size: 0.875rem;\n  padding-top: 0.4rem;\n  padding-bottom: 0.4rem;\n}\n\n.org-context-menu .list-group-item i {\n  font-size: 0.875rem;\n  vertical-align: -0.05em;\n}\n\n.org-tree-node {\n  border-radius: 0.35rem;\n  transition: background 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;\n  cursor: pointer;\n  user-select: none;\n}\n\n.org-tree-node:hover {\n  background: rgba(99, 102, 241, 0.06);\n}\n\n.org-tree-node.selected {\n  background: rgba(99, 102, 241, 0.12);\n  outline: 1px solid rgba(99, 102, 241, 0.35);\n}\n\n.org-tree-connector {\n  border-color: rgba(15, 23, 42, 0.08) !important;\n}\n\n.org-tree-node--supplier {\n  background: rgba(245, 158, 11, 0.07);\n}\n\n.org-tree-node--supplier:hover {\n  background: rgba(245, 158, 11, 0.12);\n}\n\n.org-tree-node--supplier.selected {\n  background: rgba(245, 158, 11, 0.18);\n  outline: 1px solid rgba(217, 119, 6, 0.4);\n}\n\n.org-tree-supplier-tag {\n  letter-spacing: 0.05em;\n  font-size: 0.58rem;\n  vertical-align: middle;\n}\n\n.org-supplier-detail-card {\n  border-radius: 0.5rem;\n  background: linear-gradient(180deg, rgba(255, 251, 235, 0.55) 0%, #fff 2rem);\n}\n\n.org-tree-level-dot {\n  width: 0.3rem;\n  border-radius: 999px;\n  align-self: stretch;\n  min-height: 1.125rem;\n}\n\n.org-detail-panel {\n  background: #fff;\n}\n\n.org-context-menu {\n  position: fixed;\n  z-index: 1050;\n  min-width: 11rem;\n  box-shadow: 0 0.5rem 1.5rem rgba(15, 23, 42, 0.15);\n}\n\n.org-pricing-priority .list-group-item {\n  font-size: 0.875rem;\n}\n\n@media (max-width: 767.98px) {\n  .org-tree-scroll {\n    max-height: 220px;\n  }\n}\n\n/* —— Landing & workspace (master UI) —— */\n.org-mgmt-hero--compact {\n  margin-bottom: 1.25rem !important;\n}\n\n.org-landing__header {\n  border-radius: 0.75rem 0.75rem 0 0;\n}\n\n.org-landing__search {\n  min-width: min(100%, 280px);\n}\n\n.org-landing__table thead th {\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: var(--bs-secondary-color);\n  border-bottom-width: 1px;\n}\n\n.org-landing__row {\n  transition: background 0.15s ease;\n}\n\n.org-landing__row:hover {\n  background: rgba(13, 110, 253, 0.04);\n}\n\n.org-empty-state__icon {\n  font-size: 2.5rem;\n  color: var(--bs-secondary-color);\n  opacity: 0.45;\n}\n\n.org-workspace-tabs .nav-link {\n  border: 1px solid transparent;\n  color: var(--bs-secondary-color);\n  font-weight: 500;\n  font-size: 0.875rem;\n  padding: 0.5rem 1rem;\n  transition: color 0.15s ease, background 0.15s ease, border-color 0.15s ease;\n}\n\n.org-workspace-tabs .nav-link:hover {\n  color: var(--bs-primary);\n  background: rgba(13, 110, 253, 0.06);\n}\n\n.org-workspace-tabs .nav-link.active {\n  color: var(--bs-primary);\n  background: #fff;\n  border-color: rgba(15, 23, 42, 0.08);\n  border-bottom-color: #fff;\n  margin-bottom: -1px;\n}\n\n.org-workspace-card {\n  border: 1px solid rgba(15, 23, 42, 0.08) !important;\n  border-top: none !important;\n  border-radius: 0 0 0.75rem 0.75rem !important;\n  background: #fff;\n  min-height: 280px;\n}\n\n.org-panel-card {\n  border-radius: 0.75rem !important;\n}\n\n.org-details-tab .form-label {\n  font-weight: 500;\n}\n\n.org-accordion .accordion-button {\n  font-weight: 600;\n  font-size: 0.875rem;\n  padding: 0.65rem 1rem;\n}\n\n.org-accordion .accordion-button:not(.collapsed) {\n  background: rgba(13, 110, 253, 0.06);\n  color: var(--bs-body-color);\n}\n\n/* Customer onboarding — tabbed form (replaces accordion) */\n.customer-onboard-tabs {\n  position: relative;\n  z-index: 1;\n}\n\n.customer-onboard-pan {\n  border-color: rgba(15, 23, 42, 0.08) !important;\n  min-height: 320px;\n}\n\n.customer-onboarding-form .cust-form-block:not(:last-child) {\n  border-bottom: 1px solid rgba(15, 23, 42, 0.06);\n  padding-bottom: 1.25rem;\n  margin-bottom: 1.5rem !important;\n}\n\n/* Compact react-select — same visual scale as User Management (form-control-sm) */\n.customer-onboarding-form .react-select__control,\n.org-details-tab .react-select__control {\n  min-height: 31px;\n  font-size: 0.875rem;\n}\n\n.customer-onboarding-form .react-select__single-value,\n.customer-onboarding-form .react-select__input-container,\n.customer-onboarding-form .react-select__placeholder,\n.org-details-tab .react-select__single-value,\n.org-details-tab .react-select__input-container,\n.org-details-tab .react-select__placeholder {\n  font-size: 0.875rem;\n}\n\n.customer-onboarding-form .react-select__indicators,\n.org-details-tab .react-select__indicators {\n  height: 29px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
